// Contentful
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { RENDER_DOCUMENT_OPTIONS } from '../../helpers/contentful';

// Components
import GoBackButton from '../GoBackButton/GoBackButton';

const Header = (props) => {
  const { subtitle, title, description, detail, modifier, goBackButton } = props;

  return (
    <div className={`Header ${modifier || ''} ${detail ? 'is-detail' : ''}`}>
      <div className="Header-inner">
        {goBackButton && (
          <div className="Header-back">
            <GoBackButton />
          </div>
        )}
        <div className="Header-text">
          {subtitle && <div className="Header-subtitle">{subtitle}</div>}
          <h1 className="Header-title">{title && title.map((label) => <span key={`title-${label}`}>{label}</span>)}</h1>
          <div className="Header-description">{documentToReactComponents(description, RENDER_DOCUMENT_OPTIONS)}</div>
        </div>
      </div>
    </div>
  );
};

export default Header;
